import React from 'react';
import moment from 'moment';
import { API_ENDPOINT, MKT_BASE_CURRENCY } from '../../index';
import {
    Row,
    Button,
    Popconfirm
} from 'antd'

import DownloadListModal from './download-list-modal';
import DownloadDoModal from './download-do-modal';

class PerDayButtonControls extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            downloadListModalVisible: false,
            downloadDoModalVisible: false,
        }
    }
    
    render(){

        return(
            <Row>

                {!this.props.toggleOptimizedRouteMode ? 
                    <Button  
                        type='primary' 
                        size='medium' 
                        onClick={()=>this.props.createRoute(this.props.date)}
                    >
                        Optimize EezeeSend
                    </Button> : 

                    <Button 
                        size='medium' 
                        type='primary' 
                        style={{margin:'10px'}} 
                        // icon='file-excel' 
                        href={`${API_ENDPOINT}/api/admin/delivery/downloadCsv/${moment(this.props.date).format('YYYY-MM-DD')}?mktBaseCurrency=${MKT_BASE_CURRENCY}`}
                    >
                        Route List
                    </Button>
                }

                {this.state.downloadListModalVisible && <DownloadListModal
                    visible={this.state.downloadListModalVisible}
                    onCancel={() => this.setState({ downloadListModalVisible: false })}
                    date={this.props.date}
                />}

                <Button style={{ margin: "5px" }} type='primary' size='medium' onClick={this.toggleDownloadListModalVisible}>Download List</Button>


                {
                    this.props.toggleOptimizedRouteMode && (
                        <div>
                        {this.state.downloadDoModalVisible && <DownloadDoModal
                            locationActionRequired={this.state.downloadDoLocationActionRequired}
                            visible={this.state.downloadDoModalVisible}
                            onCancel={() => this.setState({ downloadDoModalVisible: false })}
                            date={this.props.date}
                            selectedLocations={this.props.selectedLocations}
                        />}
                        <Button style={{ margin: "5px" }} type='primary' size='medium' onClick={() => this.toggledownloadDoModalVisible('delivery')}>Download DO</Button>
                        <Button style={{ margin: "5px" }} type='primary' size='medium' onClick={() => this.toggledownloadDoModalVisible('pickup')}>Download PL</Button>
                        </div>
                    )
                }

                <Button 
                    size='medium' 
                    type='primary' 
                    style={{
                        margin:'10px'
                    }} 
                    // icon='file-excel' 
                    href={`${API_ENDPOINT}/api/admin/delivery/incomplete/${moment(this.props.date).format('YYYY-MM-DD')}?mktBaseCurrency=${MKT_BASE_CURRENCY}`}
                >
                    Incomplete List
                </Button>


                {
                    !this.props.toggleOptimizedRouteMode && 
                    <Button 
                        style={{
                            margin:'10px'
                        }}
                        size='medium' 
                        type='primary' 
                        // icon='file-excel' 
                        href={`${API_ENDPOINT}/api/admin/delivery/downloadCsv-backup/${moment(this.props.date).format('YYYY-MM-DD')}?mktBaseCurrency=${MKT_BASE_CURRENCY}`} 
                        download={`${moment(this.props.date).format('YYYY-MM-DD')}.csv`}
                    >
                        Unoptimized List
                    </Button>
                }

                {
                    this.props.toggleOptimizedRouteMode && (
                        <Popconfirm
                            title="Are you sure?"
                            onConfirm = {(e)=>this.props.emailAll(e, this.props.date)} //require cartId products date
                            okText="Yes"
                            cancelText="No"
                        >
                            <Button
                                style={{ marginTop: "10px" }}
                                size='medium' 
                                type='danger' 
                                icon='mail'
                            >
                                EMAIL ALL 
                            </Button>
                        </Popconfirm>
                    )
                }
            </Row>
        )
    }

    toggleDownloadListModalVisible = () => {
        this.setState({
            downloadListModalVisible: !this.state.downloadListModalVisible
        })
    }

    toggledownloadDoModalVisible = (locationActionRequired) => {
        this.setState({
            downloadDoModalVisible: !this.state.downloadDoModalVisible,
            downloadDoLocationActionRequired: locationActionRequired
        })
    }

}
export default PerDayButtonControls;


// WEBPACK FOOTER //
// ./src/components/delivery-page/PerDayButtonControls.js